import env from 'config/env';

export default function FootWrap() {
  const department = env().DEPARTMENT || '우주모빌리티과';
  const phoneNumber = env().PHONE_NUMBER || '064-710-4826';

  return (
    <footer className="footer">
      <div className="fInfoArea">
        <div className="fInfoLeft">
          Copyright 2019 <span>제주특별자치도</span>. All rights reserved
        </div>
        <div className="fInfoRight">
          <div>
            담당부서 : <span>{department}</span>
          </div>
          <div>
            전화번호 : <span>{phoneNumber}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
